/**
 * Turns a string into a color (HSL)
 * - Ref: https://stackoverflow.com/questions/3426404/create-a-hexadecimal-colour-based-on-a-string-with-javascript
 */
export const stringToColor = (
    str: string,
    saturation: number = 50,
    lightness: number = 50
) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }

    return `hsl(${hash % 360}, ${saturation}%, ${lightness}%)`;
};
